export const HOURS = {
  OWNER:   'HOURS_OWNER',
  CACHE:   'HOURS_CACHE',
  ENQUEUE: 'HOURS_ENQUEUE',
  REPLACE: 'HOURS_REPLACE',
  DROP:    'HOURS_DROP',
  REJECT:  'HOURS_REJECT',
  DISMISS: 'HOURS_DISMISS',
}

// The cache belongs to one person: another login starts from scratch.
export const ownHours    = userId           => ({ type: HOURS.OWNER, userId })
export const cacheHours  = (key, payload)   => ({ type: HOURS.CACHE, key, payload, at: new Date().toISOString() })
export const enqueueHour = item             => ({ type: HOURS.ENQUEUE, item })
export const replaceHour = (id, patch)      => ({ type: HOURS.REPLACE, id, patch })
export const dropHours   = ids              => ({ type: HOURS.DROP, ids })
export const rejectHour  = (id, message)    => ({ type: HOURS.REJECT, id, message, at: new Date().toISOString() })
export const dismissHour = id               => ({ type: HOURS.DISMISS, id })
